<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="昵称">
              <a-input v-model="filterForm.nickname" placeholder="昵称" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="手机号">
              <a-input v-model="filterForm.phone" placeholder="手机号" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="角色">
              <a-select v-model="filterForm.role_id" allow-clear style="width: 100%" placeholder="角色" @change="onSearch">
                <a-select-option v-for="role in roleData" :key="role.role_id" :value="role.role_id">{{ role.role_name }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-model="filterForm.email" label="邮箱">
              <a-input v-model="filterForm.email" placeholder="邮箱" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="getUserList">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="用户列表" size="small" class="filter-data">
      <span slot="extra">
        <a-button v-show="false" class="handle-menu" type="primary" icon="plus" @click="onAdd">添加</a-button>
      </span>
      <a-table :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a v-dis="{ code: 'system:user:edit', project: 0 }" @click="onEdit(record)">编辑</a>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge :status="record.status === 0 ? 'success' : 'warning'" :text="record.status === 0 ? '启用' : '禁用'" />
        </span>
        <span slot="avatar" slot-scope="text, record">
          <a-avatar shape="square" size="large" icon="user" :src="record.avatarUrl" class="table-image" />
        </span>
        <span slot="roles" slot-scope="text, record">
          <a-tag v-for="role in record.roles" :key="role.role_id" color="pink">{{ role.role_name }}</a-tag>
        </span>
      </a-table>
    </a-card>
    <UserModal :is-show="modalVisible" :user-id="userId" :user-info="userInfo" @close="close" />
  </div>
</template>

<script>
import UserModal from '@/pages/system/components/UserModal';
import { userRoleList, userDelete, roleList } from '@/api/system/auth';
const columns = [
  {
    title: '头像',
    dataIndex: 'avatar_url',
    key: 'avatar_url',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'avatar' }
  },
  {
    title: '用户ID',
    dataIndex: 'id',
    key: 'id',
    width: '5%'
  },
  {
    title: '昵称',
    dataIndex: 'nickname',
    key: 'nickname',
    width: '10%'
  },
  {
    title: '手机号',
    key: 'phone',
    width: '13%',
    dataIndex: 'phone'
  },
  {
    title: '邮箱',
    key: 'email',
    width: '20%',
    dataIndex: 'email'
  },
  {
    title: '角色',
    width: '20%',
    scopedSlots: { customRender: 'roles' }
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    align: 'center',
    width: '10%',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '创建时间',
    key: 'created_time',
    dataIndex: 'created_time',
    width: '15%',
    align: 'center'
  },
  {
    title: '操作',
    align: 'center',
    width: 80,
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  components: {
    UserModal
  },
  data() {
    return {
      loading: false,
      filterForm: {
        nickname: null,
        phone: null,
        email: null
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 10, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      userInfo: {},
      modalVisible: false,
      userId: null,
      expand: false,
      tableData: [],
      roleData: [],
      columns
    };
  },
  created() {
    this.getUserList();
    this.getRoleList();
  },
  methods: {
    getRoleList() {
      roleList({ role_type: 1 }).then(response => {
        this.roleData = response.data.roles;
      });
    },
    // 点击添加
    onAdd() {
      this.userId = null;
      this.userInfo = {};
      this.modalVisible = true;
    },

    // 点击编辑
    onEdit(user) {
      this.userId = user.id;
      this.userInfo = {
        nickname: user.nickname,
        phone: user.phone,
        email: user.email,
        roles: user.roles.map(item => {
          return item.role_id;
        })
      };
      this.modalVisible = true;
    },

    // 删除用户
    onDelete(id) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该用户吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          userDelete({ id: id, user_group_id: 1 }).then(() => {
            self.$message.success('删除成功');
            self.getUserList();
          });
        }
      });
    },
    toggle() {
      this.expand = !this.expand;
    },

    // 获取用户列表
    getUserList() {
      userRoleList({
        ...this.filterForm,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      }).then(res => {
        this.tableData = res.data.items;
        this.pagination.total = res.data.total;
      });
    },

    reset() {
      this.filterForm = {
        nickname: null,
        phone: null,
        email: null
      };
      this.getUserList();
    },

    onSearch() {
      this.pagination.current = 1;
      this.getUserList();
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.getUserList();
    },

    // 关闭弹窗
    close(type) {
      this.modalVisible = false;
      if (type === 'submit') {
        this.getUserList();
      }
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
</style>
